import { Injectable, inject } from '@angular/core';

import { Plan, ProductFactory, Pto } from '@bytel/bytel-sales';
import { CheckoutStorageService, STORAGE_TAGS, UPDATE_ACTIONS } from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';

import { Observable, of } from 'rxjs';

import { ConfigurationService } from './configuration.service';

@Injectable({
    providedIn: 'root',
})
export class PtoService {
    public static readonly storage_key: string = 'pto_data';
    public _currentPto: Pto = null;
    public ptoChoice: string = null;

    protected configurationService: ConfigurationService = inject(ConfigurationService);

    public constructor(
        private cartService: MainCartService,
        private storageService: CheckoutStorageService,
    ) {
        this.storageService.addLocalKey({
            [PtoService.storage_key]: [STORAGE_TAGS.ORDER],
        });
        this.cartService.productActionObs.subscribe((data) => {
            if (data.action === UPDATE_ACTIONS.ADD && ProductFactory.Is(data.product, Plan)) {
                this.reset();
            }
        });
        this._currentPto = this.storageService.get(PtoService.storage_key);
    }

    /**
     * Save PTO data
     * @param pto Pto
     * @returns Observable true / false
     */
    public save(pto: Pto): Observable<boolean> {
        this._currentPto = pto;
        this.storageService.set(PtoService.storage_key, pto);
        return of(true);
    }

    public getPto(): Pto {
        return this._currentPto;
    }

    public reset(): void {
        this._currentPto = null;
        this.storageService.remove(PtoService.storage_key);
    }
}
